module.exports = __webpack_public_path__ + "img/backyard-alt-angle.5caa2a70.jpg";